import { useMutation } from 'react-query';

import { createGateTemplate as mutationFn } from 'api/endPoints/createGateTemplate';

import { ICreateTemplate } from 'components/Dashboards/Portfolio/phasePerformance/manage/manage.types';

export const useMutationCreateTemplate = () => {
    return useMutation<unknown, QueryError, ICreateTemplate>((params) => mutationFn(params));
};
